import * as React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl, FormControlLabel, Grid, InputAdornment,
    InputLabel, MenuItem, Select, Switch
} from "@mui/material";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import {gql} from "@apollo/client";
import LoadingDialog from "../../components/loadingDialog";
import {mutate} from "../../lib/apollo";
import TextField from "@mui/material/TextField";

export default function ClickWallExempt (params: {exempt: any, setExempt: any, reload: any}) {
    const [loading, setLoading] = React.useState(true);
    const [hours, setHours] = React.useState(0);
    const [minutes, setMinutes] = React.useState(0);

    React.useEffect(() => {
        setLoading(false);
    }, []);

    React.useEffect(() => {
        if (params.exempt) {
            let seconds = params.exempt.seconds || 0;
            let hours = Math.floor(seconds / 3600);
            let minutes = Math.floor((seconds % 3600) / 60);
            setHours(hours);
            setMinutes(minutes);

        } else {
            setMinutes(0);
            setHours(0);
        }
    }, [params.exempt.agent]);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason == "backdropClick")
            return;
        params.setExempt({agent: '', seconds: 0, date: ''});
    };

    const handleSubmit = async (event: any) => {
        let q;
        let variables;
        let good = false;
        let seconds = hours * 3600 + minutes * 60;

            q = gql`
                mutation m($agent: String!, $date: String!, $seconds: Int!) {
                    clickWallSetExempt(agent: $agent, date: $date, seconds: $seconds)
                }
            `;

            variables = {
                agent: params.exempt.agent,
                date: params.exempt.date,
                seconds
            };

            setLoading(true);

            const res = await mutate(q, variables);
            good = res && res.clickWallSetExempt;

        if (good) {
            toast.success('Exempt Hours Set Successfully');
            setLoading(false);
            handleClose();
            params.reload();
        } else {
            setLoading(false);
        }

    }

    if (!params.exempt.agent) return <> </>;

    return (
        <>
                <Dialog
                    open={!!params.exempt.agent}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'sm'}
                    fullWidth={true}
                >
                    <DialogTitle id="alert-dialog-title">
                        Update Exempt: {params.exempt.agent} ({params.exempt.date})
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    autoComplete={'off'}
                                    margin="dense"
                                    id="hours"
                                    label="Hours"
                                    type="number"
                                    fullWidth
                                    size={'small'}
                                    value={hours}
                                    onChange={(e) => setHours(parseInt(e.target.value || "0"))}
                                    inputProps={{
                                        step: "1"
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    autoComplete={'off'}
                                    margin="dense"
                                    id="hours"
                                    label="Minutes"
                                    type="number"
                                    fullWidth
                                    size={'small'}
                                    value={minutes}
                                    onChange={(e) => setMinutes(parseInt(e.target.value || "0"))}
                                    inputProps={{
                                        step: "1"
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    {loading ? <LoadingDialog/> :
                    <DialogActions>
                        <Button sx={{color: 'red'}} onClick={handleClose}>Close</Button>
                        <Button sx={{color: 'green'}} onClick={handleSubmit} autoFocus>Set</Button>
                    </DialogActions>
                    }
                </Dialog>
        </>
    )
}
